(() => {
  if (window.location?.pathname !== "/pages/search-results") return;

  const helpCenterBlogObjectId = "81825136698";
  const legacyBlogTitleFilter = /\bblog\.title\s*:/;

  const normalizeSearchResultsConfigureParams = (params) => {
    if (
      !params ||
      typeof params !== "object" ||
      !legacyBlogTitleFilter.test(String(params.filters || ""))
    ) {
      return params;
    }

    const nextParams = { ...params };
    delete nextParams.filters;

    const numericFilters = Array.isArray(nextParams.numericFilters)
      ? [...nextParams.numericFilters]
      : nextParams.numericFilters
        ? [nextParams.numericFilters]
        : [];
    const helpCenterFilter = `blog.objectID=${helpCenterBlogObjectId}`;

    if (!numericFilters.includes(helpCenterFilter)) {
      numericFilters.push(helpCenterFilter);
    }

    nextParams.numericFilters = numericFilters;

    return nextParams;
  };

  const patchInstantSearch = (instantsearchInstance) => {
    const widgets = instantsearchInstance?.widgets;

    if (
      !widgets ||
      typeof widgets.configure !== "function" ||
      widgets.configure.__ygSearchResultsBlogPatch
    ) {
      return;
    }

    const configure = widgets.configure;

    widgets.configure = function patchedConfigure(params) {
      return configure.call(this, normalizeSearchResultsConfigureParams(params));
    };
    widgets.configure.__ygSearchResultsBlogPatch = true;
  };

  let instantsearchInstance = window.instantsearch;

  try {
    Object.defineProperty(window, "instantsearch", {
      configurable: true,
      get() {
        return instantsearchInstance;
      },
      set(value) {
        instantsearchInstance = value;
        patchInstantSearch(value);
      },
    });
  } catch (error) {
    patchInstantSearch(instantsearchInstance);
    return;
  }

  patchInstantSearch(instantsearchInstance);
})();

class YgProductCollapse extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    this.button = this.querySelector(".yg-product-card-button");
    this.content = this.querySelector(".yg-product-more-content");

    if (!this.button || !this.content) return;


    this.content.style.height = "0px";
    this.content.style.overflow = "hidden";
    this.content.style.transition = "height 0.3s ease";

    this.button.addEventListener("click", () => {
      this.toggle();
    });
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.classList.add("is-open");

    const paddingTop = 16;


    this.content.style.paddingTop = "0px";

    const height = this.content.scrollHeight + paddingTop;


    this.content.style.paddingTop = paddingTop + "px";
    this.content.style.height = height + "px";

    this.content.addEventListener(
      "transitionend",
      () => {
        if (this.isOpen) {

          this.content.style.height = "auto";
        }
      },
      { once: true }
    );
  }

  close() {
    this.isOpen = false;
    this.classList.remove("is-open");

    const paddingTop = 16;


    const height = this.content.scrollHeight + paddingTop;
    this.content.style.height = height + "px";

    requestAnimationFrame(() => {

      this.content.style.height = "0px";
      this.content.style.paddingTop = "0px";
    });
  }
}

if (!customElements.get("yg-product-collapse")) {
  customElements.define("yg-product-collapse", YgProductCollapse);
}

class YGDownload extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.addEventListener("click", this.handleDownload.bind(this));
  }

  handleDownload(event) {
    event.preventDefault();

    const downloadLink = this.getAttribute("data-download-link");
    if (!downloadLink) {
      console.warn("YGDownload: No data-download-link attribute found");
      return;
    }


    (async () => {
      try {
        const response = await fetch(downloadLink, { mode: "cors" });
        if (!response.ok)
          throw new Error("Network response was not ok: " + response.status);

        const blob = await response.blob();


        let filename = this.getAttribute("data-download-filename") || "";
        const disposition =
          response.headers.get("Content-Disposition") ||
          response.headers.get("content-disposition");
        if (!filename && disposition) {
          const match = disposition.match(
            /filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/i
          );
          if (match && match[1]) {
            filename = decodeURIComponent(match[1]);
          }
        }

        if (!filename) {

          try {
            filename = new URL(downloadLink).pathname.split("/").pop() || "";
          } catch (e) {
            filename = downloadLink.split("/").pop().split("?")[0];
          }
        }

        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = blobUrl;

        if (filename) a.download = filename;
        else a.download = "";
        document.body.appendChild(a);
        a.click();
        a.remove();

        setTimeout(() => URL.revokeObjectURL(blobUrl), 30000);
        console.log(
          "YGDownload: blob download initiated for",
          downloadLink,
          "as",
          filename
        );
      } catch (err) {

        try {
          const link = document.createElement("a");
          link.href = downloadLink;
          link.download = this.getAttribute("data-download-filename") || "";
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          console.warn(
            "YGDownload: fallback download attempted for",
            downloadLink
          );
        } catch (e) {
          console.error("YGDownload: Failed to download file", e);
        }
      }
    })();
  }
}

if (!customElements.get("yg-download")) {
  customElements.define("yg-download", YGDownload);
}

class YGMegaMenuTab extends HTMLElement {
  constructor() {
    super();
    this.tabs = null;
    this.items = null;
    this.tabHandlers = [];
    this.handleResize = this.handleResize.bind(this);
    this.init();
  }
  init() {
    this.tabs = this.querySelectorAll(".yg-tab-item");
    this.items = this.querySelectorAll(".yg-content-item");
    if (this.tabs.length === 0 || this.items.length === 0) return;


    this.tabs.forEach((tab, i) => {
      tab.classList.toggle("active", i === 0);
      if (this.items[i]) this.items[i].classList.toggle("active", i === 0);
    });


    this.handleResize();
    window.addEventListener("resize", this.handleResize);

  }

  switchTab(index) {
    this.tabs.forEach((t, j) => t.classList.toggle("active", index === j));
    this.items.forEach((p, j) => p.classList.toggle("active", index === j));
  }

  handleResize() {
    const isMobile = window.innerWidth < 1150;


    this.tabHandlers.forEach(({ tab, handler, type }) => {
      tab.removeEventListener(type, handler);
    });
    this.tabHandlers = [];


    this.tabs.forEach((tab, i) => {
      let handler;
      let type;

      if (isMobile) {

        type = "click";
        handler = () => this.switchTab(i);
      } else {

        type = "mouseenter";
        handler = () => this.switchTab(i);
      }

      tab.addEventListener(type, handler);
      this.tabHandlers.push({ tab, handler, type });
    });
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);

    this.tabHandlers.forEach(({ tab, handler, type }) => {
      tab.removeEventListener(type, handler);
    });
  }
}

if (!customElements.get("yg-mega-menu-tab")) {
  customElements.define("yg-mega-menu-tab", YGMegaMenuTab);
}

class YGItemProducts extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const products = this.querySelector(".yg-item-products");

    const panelWrapper = this.closest(".panel__wrapper");
    panelWrapper.removeAttribute('hidden');
    const contentHeight = products.offsetHeight;
    const scrollHeight = products.scrollHeight;
    panelWrapper.setAttribute('hidden','');
    if (contentHeight < scrollHeight) {

      const moreWrapper = this.querySelector(".yg-more-content");
      moreWrapper.classList.remove("hide");
      const moreButton = this.querySelector(".yg-more-content .yg-button-outline");
      const dropContainer = this.closest(".yg-dropdown-content-container");
      moreButton.addEventListener("click", () => {
        products.classList.add("active");
        moreWrapper.classList.add("hide");
        dropContainer.style.setProperty("--height", products.scrollHeight + "px");
      });
    }


  }
}

if (!customElements.get("yg-item-products")) {
  customElements.define("yg-item-products", YGItemProducts);
}

class YGBuyNow extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.addEventListener("click", this.handleClick.bind(this));
  }
  handleClick(event) {
    const button = event.target.closest("button");
    if (!button || button.disabled) return;

    event.preventDefault();
    const productForm =
      document.getElementById(this.getAttribute("form")) || this.closest("form");

    if (!productForm || productForm.dataset.ygDirectCheckout === "true") return;

    if (!productForm.checkValidity()) {
      productForm.reportValidity();
      return;
    }

    productForm.dataset.ygDirectCheckout = "true";
    productForm.addEventListener(
      "cart:error",
      () => delete productForm.dataset.ygDirectCheckout,
      { once: true }
    );
    productForm.requestSubmit();
  }
}
if (!customElements.get("yg-buy-now")) {
  customElements.define("yg-buy-now", YGBuyNow);
}

const CALENDLY_WIDGET_SCRIPT_URL =
  "https://assets.calendly.com/assets/external/widget.js";
const CALENDLY_WIDGET_STYLE_URL =
  "https://assets.calendly.com/assets/external/widget.css";

let calendlyWidgetPromise = null;

function ensureCalendlyWidgetStyles() {
  if (document.querySelector('link[data-calendly-widget-style="true"]')) return;

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = CALENDLY_WIDGET_STYLE_URL;
  link.dataset.calendlyWidgetStyle = "true";
  document.head.appendChild(link);
}

function loadCalendlyWidget() {
  if (window.Calendly?.initPopupWidget) {
    return Promise.resolve(window.Calendly);
  }

  if (calendlyWidgetPromise) {
    return calendlyWidgetPromise;
  }

  ensureCalendlyWidgetStyles();

  calendlyWidgetPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      'script[data-calendly-widget-script="true"]'
    );
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement("script");
    script.src = CALENDLY_WIDGET_SCRIPT_URL;
    script.async = true;
    script.dataset.calendlyWidgetScript = "true";
    script.onload = () => resolve(window.Calendly);
    script.onerror = () => {
      script.remove();
      calendlyWidgetPromise = null;
      reject(new Error("Failed to load Calendly widget script"));
    };
    document.head.appendChild(script);
  });

  return calendlyWidgetPromise;
}

document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".shopify-section");

  function isDarkColor(rgb) {
    const values = rgb.match(/\d+/g);
    if (!values) return false;

    const r = parseInt(values[0], 10);
    const g = parseInt(values[1], 10);
    const b = parseInt(values[2], 10);


    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness < 128;
  }

  function getGradientFirstColor(bgImage) {
    const match = bgImage.match(/rgb[a]?\([^)]+\)/);
    return match ? match[0] : null;
  }


  sections.forEach(section => {
    const style = getComputedStyle(section);
    let bgColor = style.backgroundColor;
    const bgImage = style.backgroundImage;


    if (bgImage && bgImage !== 'none') {
      const gradientColor = getGradientFirstColor(bgImage);

      if (gradientColor) {
        bgColor = gradientColor;
      }
    }


    if (bgColor === 'rgba(0, 0, 0, 0)' || bgColor === 'transparent') {
      section.classList.add('is-light');
      section.classList.remove('is-dark');
      return;
    }


    if (isDarkColor(bgColor)) {
      section.classList.add('is-dark');
      section.classList.remove('is-light');
    } else {
      section.classList.add('is-light');
      section.classList.remove('is-dark');
    }
  });


  const navDrawer = document.getElementById('header-sidebar-menu');
  const closeButtons = navDrawer.querySelectorAll('.yg-link-top-cross');
  closeButtons.forEach((closeBtn) => {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (navDrawer.hide) {
        navDrawer.hide();
      } else {
        navDrawer.removeAttribute('open');
      }
    });
  });


  const vrIframes = document.querySelectorAll('.yg-vr-iframe-lazy');
  const iframeObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.src = entry.target.getAttribute('data-src');
      }
    });
  });
  vrIframes.forEach((vrIframe) => {
    iframeObserver.observe(vrIframe);
  });


  const videos = document.querySelectorAll('.yg-video-lazy');
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.src = entry.target.getAttribute('data-src');
      }
    });
  });
  videos.forEach((video) => {
    videoObserver.observe(video);
  });

  document.addEventListener("click", async (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest("[data-calendly-url]");
    if (!trigger) return;

    const url = trigger.getAttribute("data-calendly-url");
    if (!url) return;

    event.preventDefault();

    try {
      await loadCalendlyWidget();

      if (window.Calendly?.initPopupWidget) {
        window.Calendly.initPopupWidget({ url });
        return;
      }
    } catch (error) {
      console.warn("Calendly widget lazy load failed", error);
    }

    const popup = window.open(url, "_blank", "noopener");
    if (!popup) {
      window.location.assign(url);
    }
  });
});
